export default class ClickablePos {
    constructor(el) {
      this.el = el;    

      this.init();
      this.initEvents();
    }
  
    init() {
        this.posBlockContainer = this.el.querySelector(".pos-block-container");
        this.downloadLink = this.el.querySelectorAll(".pos-block-action")[1];
    }
  
    initEvents() {
        this.posBlockContainer.addEventListener("click", (e) => {
            this.openFile();
        });
        this.downloadLink.addEventListener("click", (e) => {
            e.stopPropagation();
        });
    }

    openFile() {
        window.open(this.posBlockContainer.dataset.link, '_blank');
    }
}
  